import React from 'react';
import { Divider, Flex } from 'antd';
import { LoanPhases } from 'scenes/Private/Dashboard/LoanPhases.constanst';
import { TagStatus } from './SharedComponents';
import { LenderTaskItem } from './LenderTaskItem';
import { BorrowerTaskItem } from './BorrowerTaskItem';

// SVG imports
import checkSvg from 'assets/images/check-circle.svg';
import alertSvg from 'assets/images/alert-circle.svg';
import checkCircleSvg from 'assets/images/check-circle.svg';
import { LoanTypes } from 'services/loan/type.constansts';

interface PhaseModalProps {
  loan: any;
  phaseSelect: LoanPhases;
  phases: LoanPhases[];
  tasks: any[];
  loanDocs: any[];
  onClickPhaseProgress: (phase: LoanPhases) => void;
  handlerSetTaskOpenModal: (key: string) => void;
  setShowLoanDetailsModal: (show: boolean) => void;
}

export const PhaseModal: React.FC<PhaseModalProps> = ({
  loan,
  phaseSelect,
  phases,
  tasks,
  loanDocs,
  onClickPhaseProgress,
  handlerSetTaskOpenModal,
  setShowLoanDetailsModal
}) => {
  const filteredLenderTasks = phaseSelect.lenderTasks?.filter((item: any) => {
    if (item.exclude) return false;
    return !(loan?.type === LoanTypes.RENTAL && item.key === 'track_record_verified')
  })
  return (
    <>
      <div className='content-bar-status'>
        {phases?.map((tab: any) => (
          <div
            className={`tab tab-${tab.state}`}
            key={tab.key}
            onClick={() => onClickPhaseProgress(tab)}
          >
            <div className={`bar-status ${phaseSelect?.key === tab.key && 'bar-status-selected'}`}>
              {phaseSelect?.key !== tab.key && (
                <div className='text-status'>
                  {tab.state === 'complete' && (
                    <img src={checkSvg} alt="check" className="check" />
                  )}
                  {(tab.state === 'error' || tab.state === 'blocked') && (
                    <img src={alertSvg} alt="error" />
                  )}
                  <span>{tab.stateName}</span>
                </div>
              )}
            </div>
            <p className="body-small body-small-w4">{tab.name}</p>
          </div>
        ))}
      </div>
      
      <div className={`content-phase-select content-phase-select-${phaseSelect.state}`}>
        <TagStatus state={phaseSelect.state ?? ''} stateName={phaseSelect.stateName ?? ''} />
        
        <Flex className='content-phase' vertical={false}>
          {/* Phase Info */}
          <div className='content-phase-first'>
            <b>{phaseSelect.name}</b>
            <p>{phaseSelect.description}</p>
          </div>
          
          <Divider type="vertical" className="divider" />
          
          {/* Lender Tasks */}
          <div className='content-phase-second'>
            <b>LENDER TASKS</b>
            {(!phaseSelect.lenderTasks || phaseSelect.lenderTasks?.length === 0) ? (
              <div className={`task-item`}>
                <img src={checkCircleSvg} alt="check" className="check" />
                <div>
                  <b className='bold'>There are no tasks at this time.</b>
                  <br />
                  <span>Check back later!</span>
                </div>
              </div>
            ) : (
              filteredLenderTasks?.map(item => (
                <LenderTaskItem
                  key={item.id}
                  item={item}
                  tasks={tasks}
                  loanDocs={loanDocs}
                  setShowLoanDetailsModal={setShowLoanDetailsModal}
                />
              ))
            )}
          </div>
          
          {/* Borrower Tasks */}
          <div className='content-phase-third'>
            <b>BORROWER TASKS</b>
            {phaseSelect.tasksItems.length === 0 ? (
              <div className={`task-item`}>
                <img src={checkCircleSvg} alt="check" className="check" />
                <div>
                  <b className='bold'>There are no tasks at this time.</b>
                  <br />
                  <span>Check back later!</span>
                </div>
              </div>
            ) : (
              phaseSelect.tasksItems.map(item => (
                <BorrowerTaskItem
                  key={item.id}
                  item={item}
                  tasks={tasks}
                  handlerSetTaskOpenModal={handlerSetTaskOpenModal}
                />
              ))
            )}
          </div>
        </Flex>
      </div>
    </>
  );
};